module.exports = __webpack_public_path__ + "static/media/colors.8104e6f5.svg";